import { render, staticRenderFns } from "./manage-tags.vue?vue&type=template&id=0a8a61d0&scoped=true&"
import script from "./manage-tags.vue?vue&type=script&lang=js&"
export * from "./manage-tags.vue?vue&type=script&lang=js&"
import style0 from "./manage-tags.vue?vue&type=style&index=0&id=0a8a61d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a61d0",
  null
  
)

component.options.__file = "manage-tags.vue"
export default component.exports